import classNames from "classnames";
import React, { PropTypes } from "react";
import { FormattedDate, FormattedMessage, FormattedTime, intlShape } from "react-intl";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../enums/clientStatusTypes";
import {
  ADMINISTRATOR,
  AGENT,
  DIRECTOR,
  FINTECH,
  HIGH_MANAGEMENT_WITH_FINANCE,
  INFORMATION_AGENT,
  INTERNAL_ROLES,
  MANAGER,
  PLAN_ADMINISTRATOR,
} from "../../../../utils/Roles";
import userHasAccess from "../../../../utils/userHasAccess";
import { EditButton, MessageBox } from "../../../common";

import moment from "moment";
import { Link } from "react-router";
import { EnumValue, EnumWrapper } from "../../../../utils/enums";
import BasicClientsFields from "../client-form/BasicClientFields";

import { connect } from "react-redux";
import { toast } from "react-toastify";
import { CLIENT_CHANGE_STATUS } from "../../../../utils/data/models";
import { ROLES } from "../../../../utils/enums/enums";
import InfoButton from "../../../common/InfoButton/InfoButton";
import { getParsedErrors, renderErrorModal, renderSuccessModal } from "../../../common/form/FieldErrorHelper";
import ChangeStatusDropDown from "./ChangeStatusDropDown";
import { Button } from "react-bootstrap";
import inactivationReasonTypes, { OTHER, LEAVING_FOR_COMPETITOR } from "../enums/inactivationReasonTypes";
import { toDayFormat, toLocaleDate } from "../../../common/dateHelper";
import ClientSyncHeader from './ClientSyncHeader';
import { MemberCoverageStatus } from "./members/member/coverage";
import { canViewSyncStatus } from "../../../common/synchronization/SynchronizationHelper";
import { CLIENT } from "../../synchronization/enums/syncElementTypes";
import { NO_SYNC } from "../enums/synchronizationOptions";
import * as clientActions from "./clientActions";
import { bindActionCreators } from "redux";

const ND = "N/D";

/**
 * Returns the CSS class corresponding to the given sync type for color-coding.
 * @param {string} syncType - The synchronization type value.
 * @returns {string} CSS class name.
 */
function getSyncTypeClassName(syncType) {
  switch (syncType) {
    case "ELIGIBILITY":
      return "sync-type--eligibility";
    case "TED_DESJARDINS":
      return "sync-type--ted-desjardins";
    default:
      return "";
  }
}

class ClientHeader extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showValidationErrorModal: false,
      showValidationSuccessModal: false,
      errorString: "",
      infoButtonFetchParams: undefined,
      currentClientStatus: undefined,
      showPlannedInactiveModal: false,
    };
    this.getRole = this.getRole.bind(this);
    this.setclientStatusType = this.setclientStatusType.bind(this);
    this.handleInfoButtonSuccess = this.handleInfoButtonSuccess.bind(this);
    this.handleInfoButtonFailure = this.handleInfoButtonFailure.bind(this);
    this.getClientNextStatus = this.getClientNextStatus.bind(this);
    this.renderStatusSimulationModals = this.renderStatusSimulationModals.bind(
      this
    );
    this.updateCurrentStatus = this.updateCurrentStatus.bind(this);
    this.canViewClient = this.canViewClient.bind(this);
    this.viewOnlyClient = this.viewOnlyClient.bind(this);

    this.canViewImplementationClient = userHasAccess(MANAGER);
    this.canViewActiveClient = userHasAccess([...HIGH_MANAGEMENT_WITH_FINANCE, MANAGER, PLAN_ADMINISTRATOR], true);
    this.canViewInactiveClient = userHasAccess(MANAGER);
    this.canViewTerminatedClient = userHasAccess(MANAGER);

    this.canViewInactivationPlanification = userHasAccess(AGENT); /** To be implemented after 4.0 merge. */

    this.canUseStatusDropDown = userHasAccess(DIRECTOR);
    this.canViewLastActiveInfo = userHasAccess(AGENT);
    this.canEditImplementation = userHasAccess(
      HIGH_MANAGEMENT_WITH_FINANCE,
      true
    );
    this.canEditActive = userHasAccess([...HIGH_MANAGEMENT_WITH_FINANCE, MANAGER], true);
    this.canEditInactive = userHasAccess(DIRECTOR);
    this.canEditTerminated = userHasAccess(FINTECH);
    this.renderLastActiveInfo = this.renderLastActiveInfo.bind(this);
    this.setShowPlannedInactiveModal = this.setShowPlannedInactiveModal.bind(this);
    this.getClientName = this.getClientName.bind(this);
    this.getLastFiveBillingPeriods = this.getLastFiveBillingPeriods.bind(this);
  }

  componentDidUpdate() {
    const { client } = this.props;
    if (client && client.clientStatusType && this.state.infoButtonFetchParams === undefined) {
      /** We use this state to check if our InfoButton is ready to send a request. */
      const nextStatus = this.getClientNextStatus();
      this.setState({
        currentClientStatus: client.clientStatusType,
      });
      if (nextStatus) {
        this.setState({
          infoButtonFetchParams: {
            method: "POST",
            endpoint: CLIENT_CHANGE_STATUS.path.replace("{}", this.props.client.clientId),
            body: { "newStatus": nextStatus, "isSimulation": true }
          }
        });
      }
      else {
        this.setState({ infoButtonFetchParams: null });
        /** If infoButtonFetchParams === null, it means that there's no nextStatus possible for the client.
         * We use undefined as a default value to check if the verification in this code block has already been done or not
         * This is to avoid setting state unnecessarily.
         */
      }
    }
  }
  getRole(roleId) {
    switch (roleId) {
      case FINTECH.roleId:
        return (
          <FormattedMessage id="clients.form.additionalConfigurations.fintech" />
        );

      case ADMINISTRATOR.roleId:
        return (
          <FormattedMessage id="clients.form.additionalConfigurations.admin" />
        );

      default:
        return (
          <EnumWrapper enum={ROLES}>
            <EnumValue enumKey={roleId} />
          </EnumWrapper>
        );
    }
  }

  canViewClient() {
    const { client } = this.props;

    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return this.canViewImplementationClient;
      case ACTIVE.value:
        return this.canViewActiveClient;
      case INACTIVE.value:
        return this.canViewInactiveClient;
      case TERMINATED.value:
        return this.canViewTerminatedClient;
    }
  }

  viewOnlyClient() {
    const { client } = this.props;

    switch (client.clientStatusType) {
      case IMPLEMENTATION.value:
        return !this.canEditImplementation;
      case ACTIVE.value:
        return !this.canEditActive;
      case INACTIVE.value:
        return !this.canEditInactive;
      case TERMINATED.value:
        return !this.canEditTerminated;
    }
  }

  updateCurrentStatus(status) {
    this.setState({
      currentClientStatus: status,
    });
  }
  setclientStatusType(client) {
    if (client.isTERMINATED) {
      client.clientStatusType = TERMINATED.value;
      localStorage.setItem("clientStatusType", TERMINATED.value);
    } else {
      localStorage.setItem("clientStatusType", client.clientStatusType);
    }
  }

  handleInfoButtonSuccess() {
    this.setState({ showValidationSuccessModal: true });
  }

  renderLastActiveInfo() {
    const { lastActiveDate, inactivationReasonType, inactivationReasonComplement } = this.props.client;
    const { currentClientStatus } = this.state;

    if (lastActiveDate && [ACTIVE.value, INACTIVE.value].includes(currentClientStatus)) {
      let inactivationReasonTypeKey = "";
      let displayComplement = false;
      const inactivationReasonTypeEnum = inactivationReasonTypes.find((reason) => reason.value === inactivationReasonType);

      if (inactivationReasonTypeEnum) {
        inactivationReasonTypeKey = inactivationReasonTypeEnum.key;
        displayComplement = [OTHER.value, LEAVING_FOR_COMPETITOR.value].includes(inactivationReasonTypeEnum.value);
      }
      return (
        <div className="flex flex-row planned-inactive-container">
          <div className="col-direction">
            <span id="planInactiveEndDate">
              <FormattedMessage id="clients.form.client.planInactiveEndDate" />
              <span>: {toDayFormat(lastActiveDate)}</span>
            </span>
            <span id="planInactiveReason">
              <FormattedMessage id="clients.form.client.planInactiveReason" />
              <span>: <FormattedMessage id={inactivationReasonTypeKey} /></span>
            </span>
            {displayComplement &&
              <span id="planInactiveReasonComplement">
                <FormattedMessage id="clients.form.client.planInactiveReasonComplement" />
                <span>: {inactivationReasonComplement}</span>
              </span>
            }
          </div>
          {currentClientStatus == ACTIVE.value && (
            <Button
              bsStyle="primary"
              className="dataTable-action-button edit-borderless-button"
              onClick={() => this.setState({ showPlannedInactiveModal: true })}
            />
          )}
        </div>
      );
    }
  }

  setShowPlannedInactiveModal(value) {
    this.setState({ showPlannedInactiveModal: value });
  }

  handleInfoButtonFailure(e) {
    const firstColonIndex = e.data.message.indexOf(':');
    const serverMessage = e.data.message.substring(firstColonIndex + 1, e.data.message.length).trim();
    const extraData = e.data.extraData ? e.data.extraData : [];
    const userLanguage = localStorage.getItem("languageCode") || "en-CA";

    let errorCodesToString = getParsedErrors(
      serverMessage,
      userLanguage,
      "validation/clientFieldValidation/serverErrors",
      extraData
    );

    this.setState({
      showValidationErrorModal: true,
      errorString: errorCodesToString,
    });
  }

  getClientNextStatus(translated = undefined) {
    const { clientStatusType } = this.props.client;
    let possibleTransitions = { [IMPLEMENTATION.value]: ACTIVE.value };

    if (!possibleTransitions.hasOwnProperty(clientStatusType)) {
      /** No transition possible, so we return null. */
      return null;
    }

    try {
      if (translated) {
        possibleTransitions[IMPLEMENTATION.value] = ACTIVE.key;
        /** formatMessage uses translation keys to get the translated string, so we need to update the dict. */

        const { formatMessage } = this.context.intl;
        const key = possibleTransitions[clientStatusType];
        return formatMessage({ id: key });
      }
      return possibleTransitions[clientStatusType];
    } catch (e) {
      toast(
        <FormattedMessage id="validation.customMessages.serverErrors.genericError" />,
        {
          type: toast.TYPE.ERROR,
          autoClose: false,
        }
      );
    }
  }

  renderStatusSimulationModals() {
    const isStatusChangeValid = this.getClientNextStatus();
    if (!isStatusChangeValid) {
      return <i className="hidden" />;
    }
    return (
      <div>
        {renderErrorModal(
          this.state.showValidationErrorModal,
          () => this.setState({ showValidationErrorModal: false }),
          this.state.errorString,
          "validation.clientFieldValidation.clientChangeStatusValidationError"
        )}

        {renderSuccessModal(
          this.state.showValidationSuccessModal,
          () => this.setState({ showValidationSuccessModal: false }),
          "validation.clientFieldValidation.clientChangeStatusSuccessTitle",
          "validation.clientFieldValidation.clientChangeStatusValidationSuccess",
          { status: this.getClientNextStatus(true).toUpperCase() },
          { status: this.getClientNextStatus(true).toUpperCase() }
        )}
      </div>
    );
  }
  generateStatusButton(canUseStatusDropDown) {
    const { clientStatusType, lastActiveDate, inactivationReasonType, inactivationReasonComplement, coveragePeriod } = this.props.client;
    const disabled = clientStatusType === TERMINATED.value || !canUseStatusDropDown;

    return (
      clientStatusType && (
        <ChangeStatusDropDown
          initialValues={{
            clientStatusType: clientStatusType,
            lastActiveDate,
            inactivationReasonType,
            inactivationReasonComplement,
            coveragePeriod,
          }}
          client={this.props.client}
          options={[this.props.client.clientStatusType]}
          changeFieldValue={this.props.changeFieldValue}
          updateCurrentStatus={this.updateCurrentStatus}
          disabled={disabled}
          showPlannedInactiveModal={this.state.showPlannedInactiveModal}
          setShowPlannedInactiveModal={this.setShowPlannedInactiveModal}
          updateTransition={this.props.updateTransition}
        />
      )
    );
  }

  getClientName() {
    const { client } = this.props;
    const isVIP = userHasAccess(AGENT) && client.isVip === true;
    if (isVIP) {
      return (
        <div className="main-name name-border">
          <h2 className="name-title">{client.name}</h2>
        </div>
      );
    }
    else {
      return (
        <div className="main-name">
          <h2>{client.name}</h2>
        </div>
      );
    }
  }

  getLastFiveBillingPeriods() {
    return this.props.activeBillingPeriods.filter(
      (activeBillingPeriod) => {
        return !!activeBillingPeriod.startWithdrawalDate;
      }
    ).reverse().slice(0, 5);
  }

  render() {
    const {
      client,
      blocs,
      onSubmit,
      archiveButton,
      allowSubmission,
      lastGeneratedMember,
      updateClientInfo,
      clientInTransition
    } = this.props;
    const {
      adminContactEmailAddress,
      adminContactFirstName,
      adminContactJobPosition,
      adminContactLastName,
      adminContactPhoneNumber,
    } = client;
    const { infoButtonFetchParams } = this.state;
    const country = client.provinceCode
      ? client.provinceCode.slice(0, 2)
      : "CA";
    const formData = { ...client, country };
    const activeWithdrawalPeriods = this.getLastFiveBillingPeriods();
    this.setclientStatusType(client);
    const now = moment().startOf("day");
    const [
      currentWithdrawalPeriod,
      ...otherWithdrawalPeriods
    ] = activeWithdrawalPeriods;

    const withdrawalInfoClasses = classNames({
      "withdrawal-info": true,
      "has-multiple":
        !!otherWithdrawalPeriods && otherWithdrawalPeriods.length > 0,
    });
    const setWithdrawalStatusClasses = (isOpen) => {
      return classNames({
        status: true,
        open: isOpen,
        closed: !isOpen,
      });
    };
    const getWithdrawalStatus = (withdrawalPeriod) => {
      return (
        moment(withdrawalPeriod.startWithdrawalDate) <= now &&
        now <= moment(withdrawalPeriod.endWithdrawalDate)
      );
    };
    let viewOnly = userHasAccess([INFORMATION_AGENT, PLAN_ADMINISTRATOR], true);

    const createdAt =
      lastGeneratedMember &&
      lastGeneratedMember.createdAt &&
      toLocaleDate(lastGeneratedMember.createdAt);

    const currentClientStatus = this.state.currentClientStatus;
    let canViewClient = true;

    canViewClient = this.canViewClient();
    viewOnly = this.viewOnlyClient();

    const lastGeneratedMemberCoverage = {
      isInactive: lastGeneratedMember && lastGeneratedMember.isInactive,
      isInactiveReasonType: "",
      isInactiveOtherReason: ""
    };

    return (
      lastGeneratedMember && (
        <div className="page-header client-header">

          <div className="client-withdrawal">
            <div className="client-details">
              <div className="main">
                <div className="client-section">
                  <div className="client-name-section">
                    {this.getClientName()}
                    <div className="client-status-container">
                      <div className="client-status">
                        {this.generateStatusButton(this.canUseStatusDropDown)}
                        {this.renderStatusSimulationModals()}
                        {infoButtonFetchParams &&
                          currentClientStatus &&
                          currentClientStatus == IMPLEMENTATION.value &&
                          this.canUseStatusDropDown && (
                            <InfoButton
                              postRequestSuccess={this.handleInfoButtonSuccess}
                              postRequestFailure={this.handleInfoButtonFailure}
                              fetchParameters={infoButtonFetchParams}
                              inProgressToastMessageId="validation.clientFieldValidation.validationInProgress"
                            />
                          )}
                        {canViewClient && (
                          <EditButton
                            modalClassName="extra-large-modal"
                            title={
                              <FormattedMessage
                                id={`clients.datatable.actions.${viewOnly ? "view" : "edit"
                                  }`}
                              />
                            }
                            form={BasicClientsFields}
                            allowSubmission={!viewOnly && allowSubmission}
                            props={{
                              disabled: viewOnly,
                              blocs,
                              archiveButton,
                              create: false,
                              clientId: client.clientId,
                              clientName: client.name,
                              updateClientInfo: updateClientInfo,
                              automaticIdentifierConfigurationTypes: this.props.automaticIdentifierConfigurationTypes,
                            }}
                            optionalClass="fix-edit-button-margin"
                            data={formData}
                            editFunction={onSubmit}
                            confirmationTitle={
                              <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                                {(f) => <span className="icon warning">{f}</span>}
                              </FormattedMessage>
                            }
                            confirmationMessage={
                              <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
                            }
                            requiresCloseConfirmation={true}
                            confirmOnClose={true}
                          />
                        )}
                        {canViewSyncStatus(client, CLIENT) && (
                          <ClientSyncHeader updateClientInfo={updateClientInfo} client={client} />
                        )}
                      </div>

                      {this.canViewLastActiveInfo && (
                        this.renderLastActiveInfo()
                      )}
                    </div>
                  </div>
                  <div className="withdrawal-section">
                    {!!currentWithdrawalPeriod && (
                      <div className="withdrawal withdrawal-periods">
                        <div className={withdrawalInfoClasses}>
                          <div className="current-period">
                            <div className="title">
                              {currentWithdrawalPeriod.localizations[this.props.authLanguageCode].name}
                            </div>
                            <div className="withdrawal-period-content">
                              <div
                                className={setWithdrawalStatusClasses(
                                  getWithdrawalStatus(currentWithdrawalPeriod)
                                )}
                              >
                                {getWithdrawalStatus(currentWithdrawalPeriod) ? (
                                  <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriodStatus.open" />
                                ) : (
                                  <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriodStatus.closed" />
                                )}
                              </div>
                              <div className="details">
                                <span className="name">
                                  {currentWithdrawalPeriod.name}
                                </span>
                                <span className="period">
                                  <FormattedDate
                                    value={moment(
                                      currentWithdrawalPeriod.startWithdrawalDate
                                    )}
                                    year="numeric"
                                    month="short"
                                    day="2-digit"
                                    timeZone="UTC"
                                  />
                                  &nbsp;/&nbsp;
                                  <FormattedDate
                                    value={moment(
                                      currentWithdrawalPeriod.endWithdrawalDate
                                    )}
                                    year="numeric"
                                    month="short"
                                    day="2-digit"
                                    timeZone="UTC"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <ul className="withdrawal-list">
                            {otherWithdrawalPeriods.map((wp) => (
                              <li key={wp.billingPeriodId} className="current-period other-period">
                                <div className="title">
                                  {wp.localizations[this.props.authLanguageCode].name}
                                </div>
                                <div className="withdrawal-period-content">
                                  <div
                                    className={setWithdrawalStatusClasses(
                                      getWithdrawalStatus(wp)
                                    )}
                                  >
                                    {getWithdrawalStatus(wp) ? (
                                      <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriodStatus.open" />
                                    ) : (
                                      <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriodStatus.closed" />
                                    )}
                                  </div>
                                  <div className="details">
                                    <span className="period">
                                      <FormattedDate
                                        value={moment(
                                          wp.startWithdrawalDate
                                        )}
                                        year="numeric"
                                        month="short"
                                        day="2-digit"
                                        timeZone="UTC"
                                      />
                                      &nbsp;/&nbsp;
                                      <FormattedDate
                                        value={moment(
                                          wp.endWithdrawalDate
                                        )}
                                        year="numeric"
                                        month="short"
                                        day="2-digit"
                                        timeZone="UTC"
                                      />
                                    </span>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>"
                      </div>
                    )}
                  </div>
                </div>
                <div className="client-number">
                  <strong><FormattedMessage id="clients.form.otherInformation.clientNumberHeader" /></strong>
                  {" : "}
                  {client.clientNumber ? (
                    client.clientNumber
                  ) : (
                    <FormattedMessage id="common.nd" />
                  )}
                  {client.syncType != NO_SYNC.value && userHasAccess(AGENT) && (
                    <span>
                      {" - "}
                      <span className={getSyncTypeClassName(client.syncType)}>
                        <FormattedMessage id="clients.synchronizedWith" values={{syncType: client.syncType}}/>
                      </span>
                    </span>
                  )}
                </div>
                {/* Display group name if present (not shown for external roles*/}
                {userHasAccess(INTERNAL_ROLES) && client.group && (
                  <div className="client-group">
                    <span className="client-group-label">
                      <strong><FormattedMessage id="clients.header.group" /></strong>
                    </span>
                    {" : "}
                    {client.group.name}
                  </div>
                )}
                <div className="header-accounts">
                  <div className="contact">
                    <div className="name-title">
                      <h3 className="name">
                        {(adminContactFirstName || adminContactLastName) ? `${adminContactFirstName} ${adminContactLastName}` : ND}
                      </h3>
                      <span>{adminContactJobPosition ? adminContactJobPosition : ND}</span>
                    </div>
                    <div className="details">
                      <span className="detail">
                        <span className="icon icon-phone" />&nbsp;
                        {adminContactPhoneNumber ? adminContactPhoneNumber : ND}
                      </span>
                      <span className="detail">
                        <span className="icon icon-at" />&nbsp;
                        {adminContactEmailAddress ? adminContactEmailAddress : ND}
                      </span>
                    </div>
                  </div>
                  {client.accountManagerId && (
                    <div className="contact">
                      <div className="name-title">
                        <h3 className="name">
                          {client.accountManager.firstName} {client.accountManager.lastName}
                        </h3>
                        <FormattedMessage id="clients.form.otherInformation.accountManager" />
                      </div>
                      <div className="details">
                        <span className="detail">
                          <span className="icon icon-phone" />&nbsp;
                          {client.accountManager.phone ? client.accountManager.phone : ND}
                        </span>
                        <span className="detail">
                          <span className="icon icon-at" />&nbsp;
                          {client.accountManager.emailAddress ? client.accountManager.emailAddress : ND}
                        </span>
                      </div>
                    </div>
                  )}
                  {client.serviceRepresentativeId && (
                    <div className="contact">
                      <div className="name-title">
                        <h3 className="name">
                          {client.serviceRepresentative.firstName} {client.serviceRepresentative.lastName}
                        </h3>
                        <FormattedMessage id="clients.form.otherInformation.serviceRepresentative" />
                      </div>
                      <div className="details">
                        <span className="detail">
                          <span className="icon icon-phone" />&nbsp;
                          {client.serviceRepresentative.phone ? client.serviceRepresentative.phone : ND}
                        </span>
                        <span className="detail">
                          <span className="icon icon-at" />&nbsp;
                          {client.serviceRepresentative.emailAddress ? client.serviceRepresentative.emailAddress : ND}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="member-info">
                  <div className="last-member-generated">
                    <div className="last-member-col">
                      <div className="sub-title">
                        <FormattedMessage id="clients.form.otherInformation.lastMemberGenerated" />
                      </div>
                      <div className="details">
                        {lastGeneratedMember.memberName ? (
                          <Link
                            to={`/dashboard/clients/${lastGeneratedMember.clientId}/members/${lastGeneratedMember.memberId}/profile`}
                            onClick={() => this.props.clientActions.setClientSelectorClient({id: lastGeneratedMember.clientId, name: lastGeneratedMember.clientName})}
                          >
                            {lastGeneratedMember.memberName}
                          </Link>
                        ) : (
                          <FormattedMessage id="common.nd" />
                        )}
                      </div>
                    </div>
                    <div className="last-member-col">
                      <div className="sub-title">
                        <FormattedMessage id="members.datatable.columns.memberIdentifier" />
                      </div>
                      <div className="details">
                        <span>
                          {lastGeneratedMember.memberIdentifier ? (
                            lastGeneratedMember.memberIdentifier
                          ) : (
                            <FormattedMessage id="common.nd" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="last-member-col">
                      <div className="sub-title">
                        <FormattedMessage id="clients.form.otherInformation.division" />
                      </div>
                      <div className="details">
                        {" "}
                        {lastGeneratedMember.division ? (
                          lastGeneratedMember.division
                        ) : (
                          <FormattedMessage id="common.nd" />
                        )}
                      </div>
                    </div>
                    <div className="last-member-col">
                      <div className="sub-title">
                        <FormattedMessage id="members.datatable.columns.status" />
                      </div>
                      <div className="details">
                        <MemberCoverageStatus
                          businessAccountType={client.businessAccountType}
                          memberCoverage={lastGeneratedMemberCoverage}
                          authLanguageCode={this.props.authLanguageCode}
                        />
                      </div>
                    </div>
                    <div className="last-member-col">
                      <div className="sub-title">
                        <FormattedMessage id="clients.form.otherInformation.createdBy" />
                      </div>
                      <div className="details">
                        {lastGeneratedMember.createdBy ? (
                          lastGeneratedMember.createdBy
                        ) : (
                          <FormattedMessage id="common.nd" />
                        )}
                        <br />
                        {lastGeneratedMember && lastGeneratedMember.roleId ? (
                          this.getRole(lastGeneratedMember.roleId)
                        ) : (
                          <FormattedMessage id="common.nd" />
                        )}
                      </div>
                    </div>
                    <div className="last-member-col">
                      <div className="sub-title">
                        <FormattedMessage id="clients.form.otherInformation.createdOn" />
                      </div>
                      <div className="details">
                        {createdAt ? (
                          <FormattedDate
                            value={createdAt}
                            year="numeric"
                            month="long"
                            day="2-digit"
                          />
                        ) : (
                          <FormattedMessage id="common.nd" />
                        )}
                        &nbsp;-&nbsp;
                        {createdAt ? (
                          <FormattedTime
                            value={createdAt}
                            hour="numeric"
                            minute="numeric"
                          />
                        ) : (
                          <FormattedMessage id="common.nd" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {clientInTransition && (
            <MessageBox key="clientNumberWarning" className="transition-alert">
              <span className="d-flex">
                <FormattedMessage id="importExport.importMembers.form.warnings.clientInTransition" />
                <button
                  className="refresh-transition"
                  onClick={() => this.props.refetchIsTransition()}
                >
                  <span className="icon icon-loop" />
                </button>
              </span>
            </MessageBox>
          )}
        </div>
      )
    );
  }
}
ClientHeader.propTypes = {
  changeFieldValue: PropTypes.func.isRequired,
  activeBillingPeriods: PropTypes.array,
  client: PropTypes.object,
  blocs: PropTypes.array,
  onSubmit: PropTypes.func,
  archiveButton: PropTypes.func,
  allowSubmission: PropTypes.bool,
  lastGeneratedMember: PropTypes.object,
  updateClientInfo: PropTypes.func,
  clientInTransition: PropTypes.bool,
  updateTransition: PropTypes.func,
  refetchIsTransition: PropTypes.func,
  authLanguageCode: PropTypes.string,
  automaticIdentifierConfigurationTypes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  clientActions: PropTypes.func
};

ClientHeader.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  const lastGeneratedMember = state.clientActions.data;
  return {
    authLanguageCode: state.auth.user.languageCode,
    lastGeneratedMember,
  };
}

function mapDispatchToProps(dispatch) {
  return {
     clientActions: bindActionCreators(clientActions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientHeader);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/ClientHeader.js